<template>
    <v-container fluid>
        <v-row class="justify-center align-stretch flex-grow-1 ma-2 mt-4">
            <v-col cols="auto">
                <StatsChartCard/>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import StatsChartCard from '../components/StatsChartCard.vue';

export default {
    components: {
        StatsChartCard
    }
}
</script>